import { Build } from "@stencil/core";
function extractLabels() {
    if (Build.isBrowser || Build.isTesting) {
        return uvexStyleGuide.lang || {};
    }
    else if (Build.isServer) {
        return JSON.parse(document.querySelector('body').getAttribute('data-nlx-ssr-labels')) || {};
    }
    return {};
}
const labels = extractLabels();
export function translate(label, ...variables) {
    let result = labels[label];
    if (!result) {
        return '{{' + label + '}}';
    }
    if (variables.length) {
        result = variables.reduce((curry, item) => {
            return curry.replace(/%[sd]/, item);
        }, result);
    }
    return result;
}
//# sourceMappingURL=translation-service.js.map
